import { createSlice } from '@reduxjs/toolkit';

const splitbutton12GroupName= createSlice({
  name: 'groupName',
  initialState: { groupName: '' },
  reducers: {
    setGroupName: (state, action) => {
      state.groupName = action.payload;
    },
  },
});

export const { setGroupName} = splitbutton12GroupName.actions;
//export default splitbutton12GroupName.reducer;
export const splitbutton12GroupReducer = splitbutton12GroupName.reducer;


const splitbutton12WidgetName= createSlice({
  name: 'widgetName',
  initialState: { widgetName: '' },
  reducers: {
    setWidgetName: (state, action) => {
      state.widgetName = action.payload;
    },
  },
});

export const { setWidgetName} = splitbutton12WidgetName.actions;
//export default splitbutton12WidgetName.reducer;
export const splitButton12WidgetNameReducer = splitbutton12WidgetName.reducer;

const splitButton12WidgetDescription= createSlice({
  name: 'widgetDescription',
  initialState: { widgetDescription: '' },
  reducers: {
    setWidgetDescription: (state, action) => {
      state.widgetDescription = action.payload;
    },
  },
});

export const { setWidgetDescription} = splitButton12WidgetDescription.actions;
//export default splitButton12WidgetDescription.reducer;
export const splitButton12WidgetDescriptionReducer = splitButton12WidgetDescription.reducer;